import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-arrow",
  "use": "icon-right-arrow-usage",
  "viewBox": "0 0 13.12 12.12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.12 12.12\" id=\"icon-right-arrow\"><defs><style>#icon-right-arrow .cls-1{fill:none;stroke-miterlimit:10;stroke-width:3px;}</style></defs><g id=\"icon-right-arrow_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-right-arrow_選擇指標進階1\"><line class=\"cls-1\" y1=\"6.06\" x2=\"10\" y2=\"6.06\" /><polyline class=\"cls-1\" points=\"6 1.06 11 6.06 6 11.06\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol